/**
 * Header component
 * @returns <Header />
 */

import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { useGetCartQuery } from "../redux/apiSlice";
import { sumQuantityInCart } from "../scripts/helpers/cartFunctions";

const Header = () => {
    const url = window.location.origin;
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const { data: cart } = useGetCartQuery();

    let cartItemsQuantity = null;

    if (cart && cart.items.length > 0) {
        cartItemsQuantity = sumQuantityInCart(cart.items);
    }

    const data = {
        navigation: [
            {
                link: "/",
                label: "INICIO",
                class: "",
            },
            {
                link: "/modelos",
                label: "MODELOS",
                class: "",
            },
            {
                link: "/mantenciones",
                label: "MANTENCIONES",
                class: "",
            },
            {
                link: "/accesorios",
                label: "ACCESORIOS",
                class: "",
            },
            {
                link: "/merchandising",
                label: "MERCHANDISING",
                class: "",
            },
            {
                link: "/descuentos",
                label: "DESCUENTOS",
                class: "",
            },
            // {
            //     link: `${url}/es/posventa`,
            //     label: "POSVENTA",
            //     class: "",
            // },
            // {
            //     link: "/financiacion",
            //     label: "FINANCIACIÓN",
            //     class: "",
            // },
        ],

        secondNavigation: [
            {
                link: "/ayuda",
                label: "AYUDA",
                class: "",
            },
            {
                link: "/carrito",
                label: "CARRITO",
                class: "",
            },
        ],

        mobileNavigation: [
            {
                link: "/",
                label: "INICIO",
                class: "",
            },
            {
                link: "/modelos",
                label: "MODELOS",
                class: "",
            },
            {
                link: "/mantenciones",
                label: "MANTENCIONES",
                class: "",
            },
            {
                link: "/accesorios",
                label: "ACCESORIOS",
                class: "",
            },
            {
                link: "/merchandising",
                label: "MERCHANDISING",
                class: "",
            },
            {
                link: "/descuentos",
                label: "DESCUENTOS",
                class: "",
            },
            // {
            //     link: `${url}/es/posventa`,
            //     label: "POSVENTA",
            //     class: "",
            // },
            // {
            //     link: "/financiacion",
            //     label: "FINANCIACIÓN",
            //     class: "",
            // },
            {
                link: "/ayuda",
                label: "AYUDA",
                class: "",
            },
            {
                link: "/carrito",
                label: "CARRITO",
                class: "",
            },
        ],
    };

    const activeClass = "--active";

    const activeClassCb = ({ isActive }) => (isActive ? activeClass : "");
    const closeMobileMenu = () => setIsMobileMenuOpen(false);
    const toggleMobileMenu = () => setIsMobileMenuOpen((current) => !current);

    useEffect(() => {
        closeMobileMenu();
    }, [location.pathname, location.search, location.hash]);

    useEffect(() => {
        const htmlElement = document.documentElement;
        const bodyElement = document.body;

        htmlElement.classList.toggle("no-scroll", isMobileMenuOpen);
        bodyElement.classList.toggle("no-scroll", isMobileMenuOpen);

        return () => {
            htmlElement.classList.remove("no-scroll");
            bodyElement.classList.remove("no-scroll");
        };
    }, [isMobileMenuOpen]);

    return (
        <header className="header">
            <div className="wrapper header-container">
                <div className="header-container__logo-store">
                    <a href="/" target="_blank">
                        <img
                            src={`${window._env_.STATIC_HOST}/static/website/images/logo.png`}
                            alt="Lexus"
                        />
                    </a>
                    <NavLink to="/" className="store-text">
                        <p>TIENDA</p>
                    </NavLink>
                </div>

                <div className="header-container__navigation-store">
                    <ul>
                        {data.navigation.map((link, i) => {
                            if (link.label === "POSVENTA") {
                                return (
                                    <li key={i}>
                                        <a href={link.link} target="_blank">
                                            {link.label}
                                        </a>
                                    </li>
                                );
                            } else {
                                return (
                                    <li key={i}>
                                        <NavLink
                                            to={link.link}
                                            className={activeClassCb}
                                        >
                                            {link.label}
                                        </NavLink>
                                    </li>
                                );
                            }
                        })}
                    </ul>
                </div>

                <div className="header-container__language-store">
                    {data.secondNavigation.map((link, i) => {
                        return (
                            <NavLink
                                to={link.link}
                                key={i}
                                className={activeClassCb}
                            >
                                {link.label}{" "}
                                {link.label === "CARRITO" &&
                                    cartItemsQuantity > 0 && (
                                        <span className="cart-items">
                                            {cartItemsQuantity}
                                        </span>
                                    )}
                            </NavLink>
                        );
                    })}
                </div>

                <div
                    className={`header__menu-button header__menu-button-store${
                        isMobileMenuOpen ? " open" : ""
                    }`}
                >
                    <button
                        id="toggler"
                        className={`header-toggler${
                            isMobileMenuOpen ? " active" : ""
                        }`}
                        type="button"
                        aria-expanded={isMobileMenuOpen}
                        aria-controls="secondary-nav"
                        onClick={toggleMobileMenu}
                    >
                        <small className="toggler-text"></small>
                        <div className="toggler-icon">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </button>
                </div>

                <nav
                    className={`header__secondary-nav${
                        isMobileMenuOpen ? " open" : ""
                    }`}
                    id="secondary-nav"
                >
                    <div className="header__secondary-nav__list">
                        <ul>
                            {data.mobileNavigation.map((link, i) => {
                                if (link.label === "POSVENTA") {
                                    return (
                                        <li key={i}>
                                            <a
                                                href={link.link}
                                                onClick={closeMobileMenu}
                                            >
                                                {link.label}
                                            </a>
                                        </li>
                                    );
                                } else {
                                    return (
                                        <li key={i}>
                                            <NavLink
                                                to={link.link}
                                                className={activeClassCb}
                                                onClick={closeMobileMenu}
                                            >
                                                {link.label}
                                            </NavLink>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
